"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleText = exports.SubtitleText = exports.InstructionOutro = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InstructionOutro = exports.InstructionOutro = _styledComponents["default"].div.withConfig({
  displayName: "styles__InstructionOutro",
  componentId: "sc-1ewhzrl-0"
})(["display:flex;flex-direction:column;flex-grow:1;padding:", ";"], function (p) {
  return p.isDesktop ? '2rem' : '1rem 1rem 3.5rem';
});
var TitleText = exports.TitleText = _styledComponents["default"].div.withConfig({
  displayName: "styles__TitleText",
  componentId: "sc-1ewhzrl-1"
})(["font-size:", "px;font-weight:600;line-height:", "px;margin-top:", ";"], function (p) {
  return p.isDesktop ? 24 : 16;
}, function (p) {
  return p.isDesktop ? 32 : 24;
}, function (p) {
  return p.isDesktop ? 0 : 'auto';
});
var SubtitleText = exports.SubtitleText = _styledComponents["default"].div.withConfig({
  displayName: "styles__SubtitleText",
  componentId: "sc-1ewhzrl-2"
})(["font-size:16px;line-height:24px;margin-bottom:", ";margin-top:16px;"], function (p) {
  return p.isDesktop ? 0 : 'auto';
});
//# sourceMappingURL=styles.js.map